<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listMediumProtocol"
        title-table="Protocolo Meios"
        module="mediumProtocolSettingsModule"
        sort-name="descricao"
        :show-btn-add="verificarPermissao('ROLE_CORE_INSERIR')"
        :show-action-delete="verificarPermissao('ROLE_CORE_DELETAR')"
        @add="addNew"
        @edit="edit"
      />
      <FormMadiumProtocol v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import { verificarPermissao } from '@/auth/utils'
import FormMadiumProtocol from './forms/FormMadiumProtocol.vue'

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormMadiumProtocol
  },
  computed: {
    ...mapState('mediumProtocolSettingsModule', {
      listMediumProtocol: (state) => state.listMediumProtocol
    })
  },
  data() {
    return {
      verificarPermissao,
      showForm: false,
      columns: [
        {
          label: 'Id',
          field: 'id'
        },
        {
          label: 'Descrição',
          field: 'descricao'
        },
        {
          label: 'Ativo',
          field: 'ativo'
        },
        {
          label: 'Action',
          field: 'action'
        }
      ],
      pageConfig: {
        page: 1,
        size: 10,
        sort: 'descricao',
        order: 'asc'
      }
    }
  },
  methods: {
    addNew() {
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch('mediumProtocolSettingsModule/prepareToEdit', data)
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    }
  }
}
</script>
